import { useState } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetTitle,
} from "@/components/ui/sheet";

const LINKS = [
  { label: "Services", id: "services", testid: "navbar-nav-services" },
  { label: "Who We Serve", id: "who-we-serve", testid: "navbar-nav-who-we-serve" },
  { label: "How It Works", id: "how-it-works", testid: "navbar-nav-how-it-works" },
  { label: "Estimator", id: "estimator", testid: "navbar-nav-estimator" },
  { label: "Why Sora", id: "why-us", testid: "navbar-nav-why-us" },
  { label: "Our Promise", id: "stories", testid: "navbar-nav-stories" },
];

const go = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Navbar({ onRequestStaff, onJoinCrew }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#090A0F]/85 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="navbar-brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/sora-logo.png"
            alt="Sora Event Staffing"
            className="w-9 h-9 rounded-sm object-cover border border-white/10 transition-transform duration-300 group-hover:scale-105"
          />
          <span className="flex flex-col items-start leading-none">
            <span className="font-display font-bold text-xl tracking-wide text-white">
              SORA
            </span>
            <span className="font-mono-tactical text-[9px] uppercase tracking-[0.28em] text-sky-500">
              Event Staffing
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="text-sm text-slate-300 hover:text-sky-400 transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button
            data-testid="navbar-job-seeker-link"
            onClick={onJoinCrew}
            className="text-sm font-medium text-slate-300 hover:text-white transition-colors duration-200"
          >
            Join the Crew
          </button>
          <Button
            data-testid="navbar-cta-request-staff"
            onClick={onRequestStaff}
            className="bg-sky-500 hover:bg-sky-600 text-[#090A0F] font-bold rounded-sm px-5 transition-colors duration-200"
          >
            Request Staff
          </Button>
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button
              data-testid="navbar-mobile-menu-btn"
              className="lg:hidden text-white p-2"
              aria-label="Open menu"
            >
              <Menu className="w-6 h-6" />
            </button>
          </SheetTrigger>
          <SheetContent
            side="right"
            className="bg-[#0F111A] border-white/10 text-white w-72"
          >
            <SheetTitle className="flex items-center gap-2.5 text-left">
              <img
                src="/sora-logo.png"
                alt="Sora"
                className="w-8 h-8 rounded-sm object-cover"
              />
              <span className="font-display text-white text-xl font-bold">
                SORA <span className="text-sky-500">STAFFING</span>
              </span>
            </SheetTitle>
            <div className="mt-8 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`mobile-${l.testid}`}
                  onClick={() => {
                    setOpen(false);
                    go(l.id);
                  }}
                  className="text-left text-slate-300 hover:text-sky-400 transition-colors"
                >
                  {l.label}
                </button>
              ))}
              <Button
                data-testid="mobile-navbar-cta-request-staff"
                onClick={() => {
                  setOpen(false);
                  onRequestStaff();
                }}
                className="bg-sky-500 hover:bg-sky-600 text-[#090A0F] font-bold rounded-sm mt-2"
              >
                Request Staff
              </Button>
              <button
                data-testid="mobile-navbar-job-seeker-link"
                onClick={() => {
                  setOpen(false);
                  onJoinCrew();
                }}
                className="text-left text-sm text-slate-300 hover:text-white"
              >
                Join the Crew
              </button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
